var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResendInvite(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M14.542 3.958l-2.325 2.325c-.267.267-.084.717.291.717H14c0 2.758-2.242 5-5 5-.658 0-1.3-.125-1.875-.367-.3-.125-.642-.033-.867.192-.425.425-.275 1.142.284 1.367.758.308 1.591.475 2.458.475 3.683 0 6.667-2.984 6.667-6.667h1.491c.375 0 .559-.45.292-.708l-2.325-2.325c-.158-.167-.425-.167-.583-.009zM4 7c0-2.758 2.242-5 5-5 .658 0 1.3.125 1.875.367.3.125.642.033.867-.192.425-.425.275-1.142-.284-1.367C10.7.5 9.867.333 9 .333 5.317.333 2.333 3.317 2.333 7H.842c-.375 0-.559.45-.292.708l2.325 2.325c.167.167.425.167.592 0l2.325-2.325C6.05 7.45 5.867 7 5.492 7H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#1665D8",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInvite);
export default __webpack_public_path__ + "static/media/resend_invite.75d61a6ebbcd5a099ed665eb72094442.svg";
export { ForwardRef as ReactComponent };